import { cssWhen } from '../../utils/themeUtils';
import { NbButton, NbButtonProp } from '../button/Button';
import classes from './ModalFooter.module.scss';

export type ModalFooterButtonProp = {
  title: string;
  action: () => Promise<void> | void;
  disabled?: boolean;
  isLoading?: boolean;
  variant?: NbButtonProp['variant'];
  color?: NbButtonProp['color'];
};

export interface ModalFooterProps {
  left?: ModalFooterButtonProp;
  right: ModalFooterButtonProp;
  className?: string;
  children?: React.ReactNode;
}

export const ModalFooter = ({ left, right, children, className }: ModalFooterProps) => {
  return (
    <div className={cssWhen(classes.footer, [Boolean(className), className!])}>
      {left && (
        <NbButton
          color={left.color ?? 'secondary'}
          variant={left.variant}
          onClick={left.action}
          disabled={left.disabled}
          isLoading={left.isLoading}
          className={classes.footerLeftButton}
        >
          {left.title}
        </NbButton>
      )}
      {!left && <span />}

      {children}

      {right && (
        <NbButton
          onClick={right.action}
          disabled={right.disabled}
          isLoading={right.isLoading}
        >
          {right.title}
        </NbButton>
      )}
    </div>
  );
};
